import React from "react";
import styled from "styled-components";
const Header = () => {
  return (
    <HeaderWrapper>
      <Title>Gene Chan</Title>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.section`
  position: fixed;
  top: 0;
  min-width: 100%;
  margin: 0;
  padding: 2.75em;
  background-color: var(--wet-asphalt);
  z-index: 100;
  box-shadow: 1px 2px 2px 1px var(--asbestos);
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    font-size: large;
  }
`;
const Title = styled.h1`
  font-weight: bold;
  color: var(--clouds);
  text-align: left;
  text-shadow: 2px 1px 1px var(--black);
`;
export default Header;
